import { ReactComponent as StrategistIcon } from '@assets/icons/profile-icons/school-icon.svg';
import { PhoneNumber } from '@shared/serverTypes';
import { useContext } from 'react';
import { ProfileContext } from '../AccountProfile';
import StudentAsideInfo from './ProfileAsideInfo';

interface ProfileAsideStrategistProps {
  name: string;
  email: string;
  phone?: PhoneNumber;
}

const ProfileAsideStrategist = (props: ProfileAsideStrategistProps) => {
  const { name, email, phone } = props;
  const { isLoading: isProfileLoading } = useContext(ProfileContext);

  return (
    <div className="flex gap-6 py-4 px-6">
      <div className="flex gap-4 w-full">
        <StrategistIcon />
        <div className="flex flex-col gap-6 w-full">
          <h3 className="font-raleway font-bold">Education Strategist</h3>
          <StudentAsideInfo label="Name" value={name} isLoading={isProfileLoading} />
          <StudentAsideInfo label="Email" value={email} isLoading={isProfileLoading} />
          <StudentAsideInfo
            label="Phone"
            value={`${phone?.countryCode ?? ''}${phone?.number ?? ''}`}
            isLoading={isProfileLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default ProfileAsideStrategist;
